<template>
  <div class="home-list">
  <HomeLayout ref="HomeLayout" />
  <v-container grid-list-xl fluid>
    <template v-if="user" >
      <v-row justify="center">

        <v-col cols="12" :sm="sizeorder" :md="sizeorder" v-if="hasOrderListDoubleRole">
          <div v-for="bloc in user.profilInterface.blocs" :key="bloc" >
            <orderListDoubleRole class="mb-5" ref="orderListDoubleRole" :supervision="supervision" v-if="bloc == 'orderListDoubleRole'" :role="hasPrinterList"/>
          </div>
        </v-col>

        <v-col cols="12" :sm="sizeorder" :md="sizeorder" v-if="hasOrderList">
        <div v-for="bloc in user.profilInterface.blocs" :key="bloc" >
          <orderList class="mb-5" ref="orderList" :supervision="supervision" v-if="bloc == 'orderList'" :role="hasPrinterList" />
        </div>
        </v-col>

        <v-col cols="12" :sm="sizeorder" :md="sizeorder" v-if="hasOrderListNew">
          <div v-for="bloc in user.profilInterface.blocs" :key="bloc" >
            <orderListNew class="mb-5" ref="orderListNew" :supervision="supervision" v-if="bloc == 'orderListNew'" :role="hasPrinterList"/>
          </div>
        </v-col>

        <!-- <v-col cols="12" sm="12" md="12" v-if="hasPrinterList">
          <div>
            <printerList class="mb-5" :supervision="supervision" :sub="true"></printerList>
          </div>
        </v-col> -->

      </v-row>
    </template>
    </v-container>
    <Loading :visible="isLoading" />
  </div>
</template>


<script>
  import { mapActions,mapState,mapGetters } from 'vuex';
  import ListMixin from '../../mixins/ListMixin';
  import AccessMixin from '../../mixins/AccessMixin';
  import orderListDoubleRole from '../../components/order/orderprocessdoublerole';
  import orderListNew from '../../components/order/orderprocessnew';
  import orderList from '../../components/order/orderproces';
  //import printerList from '../../components/printer/parc';
  import HomeLayout from '../../components/home/Layout.vue';
  import Loading from "@/components/Loading.vue";
  export default {
      name: 'home',
      mixins: [ListMixin,AccessMixin],
      components: {
        Loading,
        HomeLayout,
        orderListDoubleRole,
        orderListNew,
        orderList,
        //printerList,
      },
      data: () => ({
        userProfil: null,
      }),
      mounted() {
        if (! this.dataUser('profil')) {
          this.userGetData({data: 'profil'});
        } else {
          this.user = this.dataUser('profil');
        }
      },

      methods: {
        ...mapActions({
          userGetData: 'user/data'
        }),
      },

      computed: {
        ...mapState('user', {
          actioned: 'actioned',
          action: 'action',
          updatedata: 'updatedata',
          error: 'error',
          isLoading: 'isLoading',
        }),

        ...mapGetters('user',{
          dataUser: 'data',
        }),

        user: {
          get() { return this.userProfil },
           set(value) { this.userProfil = value; }
        },

        supervision() {
          if (this.user) {
            return this.user.supervision;
          }
          return false;
        },

        hasPrinterList() {
          for (let i = 0; i < this.user.profilInterface.blocs.length; i++) {
            if ( this.user.profilInterface.blocs[i] == 'printerList' && this.userHasAccess('printer_read')) {
              return true;
            }
          }
          return false;
        },

        hasOrderListDoubleRole() {
          for (let i = 0; i < this.user.profilInterface.blocs.length; i++) {
            if ( this.user.profilInterface.blocs[i] == 'orderListDoubleRole') {
              return true;
            }
          }
          return false;
        },
        
        hasOrderListNew() {
          for (let i = 0; i < this.user.profilInterface.blocs.length; i++) {
            if ( this.user.profilInterface.blocs[i] == 'orderListNew') {
              return true;
            }
          }
          return false;
        },
        hasOrderList() {
          for (let i = 0; i < this.user.profilInterface.blocs.length; i++) {
            if ( this.user.profilInterface.blocs[i] == 'orderList') {
              return true;
            }
          }
          return false;
        },

        sizeorder() {
          if (this.hasPrinterList) return 6;
          else return 10;
        },
      },
      watch: {
        updatedata: function (updatedata) {
          if (updatedata == 'profil') {
            this.user = this.dataUser('profil');
          }
        },
      }
  }
</script>
